<template>
  <div id="app">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0;display: flex " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">个人信息</span>
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
    <div class="inforTop">
      <div class="headerP">
        <div style="font-size: 25px">头像</div>
        <div style="color: #FFA500">上传真实头像,你的简历更加分</div>
      </div>
      <div class="inforImg">
        <img style="" src="@/assets/img/tx.jpg" alt="">
      </div>
    </div>
    <div class="inforSix">
      <!--<van-field label="文本" value="输入框只读" readonly />-->
      <!--<van-field label="文本" value="输入框已禁用" disabled />-->
      <van-cell-group>
        <van-field label="姓名"  readonly />
        <van-field  v-model="data.name" />
      </van-cell-group>
      <!--<p>姓名</p>-->
      <!--<p></p>-->
    </div>
    <div class="inforSix">
      <!--<van-field label="姓名"  readonly />-->
      <van-cell-group>
        <van-field label="上传头像"  readonly />
        <van-uploader v-model="fileList" :after-read="onRead" type="file" accept="image/*"  multiple />
      </van-cell-group>
      <!--<p> <input class="inforNameInput" type="file"></p>-->
      <!--<p class="inforNameInput" ><van-uploader v-model="fileList" :after-read="onRead" type="file" accept="image/*"  multiple /></p>-->
    </div>
    <div class="inforName">
      <van-cell-group>
        <van-field label="出生日期"  readonly />
        <van-field   v-model="data.birthday" />
      </van-cell-group>
      <!--<p>1994.09。28</p>-->
      <!--<p>张三</p>-->
    </div>
    <div class="inforSix">
      <!--<p>  <van-field label="出生日期"  readonly /></p>-->
      <van-cell-group >
          <van-field label="性别"  readonly />
          <!--&lt;!&ndash;<van-field   placeholder="1994.03" />&ndash;&gt;-->
        </van-cell-group>
       <van-radio-group v-model="data.sex"  direction="horizontal" >
          <van-radio name="1" value="1">男</van-radio>
          <van-radio  name="2" value="2">女</van-radio>
        </van-radio-group>
    </div>
    <div class="inforName">
      <!--<p>所在城市</p>-->
      <!--<p>北京</p>-->
      <van-cell-group>
        <van-field label="所在城市"  readonly />
        <van-field   v-model="data.residence" />
      </van-cell-group>
    </div>
    <div class="inforName">
      <van-cell-group>
        <van-field label="手机号码"  readonly />
        <van-field   v-model="data.phone" />
      </van-cell-group>
    </div>  <div class="inforName">
    <van-cell-group>
      <van-field label="邮箱"  readonly />
      <van-field  v-model="data.email" />
    </van-cell-group>
    </div>
    <div class="inforName">
      <van-cell-group>
        <van-field label="首次参加工作时间"  readonly />
        <van-field  v-model="data.workinghours" />
      </van-cell-group>
    </div>
    <div class="button">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="saveInforer()">保存</van-button>

    </div>
  </div>
</template>

<script>
  import axios from  'axios'
  export default {
    name: 'App',
    data() {
      return {
//        transitionName: 'slideleft'
        radio:"",
        data:{},
        name:"1",
        list:'',
        id:'',
        fileList:[],
        src:''
      }
    },
    mounted(){
      this.inforResume()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      inforResume(){
        this.$api.obtainMy({'userid':localStorage.getItem("userid")})
          .then(res=>{
            if(res.status==200){
             this.data= res.data[0]
              this.id=res.data[0].id
              this.data.sex=this.data.sex?`${this.data.sex}`:"";
            }
          })
          .catch(res=>{

          })
      },
      saveInforer(){
        this.$api.saveInfor({
          'data[userid]':localStorage.getItem("userid"),
          "data[name]": this.data.name,
          "data[birthday]":  this.data.birthday,
          "data[sex]":this.data.sex,
          "data[residence]": this.data.residence,
          "data[phone]": this.data.phone,
          "data[email]": this.data.email,
          "data[workinghours]":this.data.workinghours,
          "id":this.id,
          "data[photo]":this.src
        })
          .then(res=>{
            if(res.status==200){
              this.$toast("保存成功")
              this.$router.push("/editResume")
            }
          })
          .catch(res=>{

          })
      },
      onRead(file) { //头像上传
        console.log(111)
        var formData = new FormData();
        formData.append('image', file.file); //接口需要传的参数
        axios({
          url:"http://zpapi.yuexinduo.com/index/news/upload",
          method: 'post',
          data: formData,
          processData: false,// 告诉axios不要去处理发送的数据(重要参数)
          contentType: false,// 告诉axios不要去设置Content-Type请求头
          msg:1}
        ).then((res)=>{
          this.src=res.data.imgurl;
          console.log(res)
//          let src={url:res.imgurl}
//          this.fileList.push({url:res.imgurl});//将图片地址存入一个数组中
//          this.postData.push(res.data.imgurl);
        })
      },
    }
  }
</script>

<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    height: 20px;
  }
.inforTop{
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 100px;
}
  .inforImg{
    width: 80px;
    height: 80px;
  }
  .inforImg img{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
.inforName{
  width: 90%;
  margin: auto;
  border-bottom: solid 1px #DEDEDE;
}
  /*.inforName :first-child{*/
    /*color: #DEDEDE;*/
  /*}*/
.van-cell::after{
  border: 0;
}
  .inforSix{
    display: flex;
    width: 90%;
    margin: auto;
    border-bottom: solid 1px #DEDEDE;
  }
  .van-cell-group{
    width: 60%;
  }
.van-cell{
  padding: 10px 0px;

}
</style>



// WEBPACK FOOTER //
// src/components/information.vue